import { ProjectNote } from './projectNote';

export class ProjectDetails {
  projectId: string;
  projectOwnerId: string;
  companyName: string;
  projectName: string;
  industrySegmentId: number;
  projectTypeIds: number[];
  projectStatusId: number;
  projectStatusNote: string;
  projectAndProductDetails: string;
  estimatedSalesMonth: number;
  estimatedSalesYear: string;
  contactName: string;
  contactEmail: string;
  contactPhoneNumber: number;
  saleTypeId: number;
  estimatedSalesValue: number;
  confidenceToClose: string;
  confidenceToCloseId: number;
  distributorName: string;
  techResourcesNeeded: boolean;
  currencySign: string;
  date: string;
  lastUpdated: string;
  note: string;
  notes: ProjectNote[];
}
